export var ONEPASS_SHOP_ID = 69; // IMAGES

export var APP_DOWNLOAD_QR_IMG = "https://s.catch.com.au/assets/0000/0973/60b9ae8faf321792202603.jpg";
export var APPLE_STORE_DOWNLOAD_IMG = "https://s.catch.com.au/static/catch/images/app-banner/1x/app-icon--ios.png";
export var GOOGLE_PLAY_DOWNLOAD_IMG = "https://s.catch.com.au/static/catch/images/app-banner/1x/app-icon--android.png";